import __ from "lodash";

const updateParameters = (templateLines, data) => {
  const populatedLines = [];
  if (templateLines && Array.isArray(templateLines)) {
    templateLines.forEach(line => {
      if (line.includes("${")) {
        const matches = Array.from(line.matchAll(/\${(.*?)\}/g), m => m[1]);
        if (matches && matches.length > 0) {
          let updatedLine = line;
          for (let i=0; i < matches.length; i++) {
            const match = matches[i];
            if (__.has(data, match)) {
              if (data[match] && typeof data[match] === "string" && data[match].indexOf("\n") >= 0){
                updatedLine = updatedLine.replace(/\${(.*?)\}/, `<pre style="font-family:Calibri,Helvetica,Arial,San-Serif;line-height:0.2em;">${data[match].replaceAll(" ", "&nbsp;").replaceAll("\t", "&#9;")}</pre>`.replaceAll("\r", "").replaceAll("\n", ` </pre><pre style="font-family:Calibri,Helvetica,Arial,San-Serif;line-height:0.2em;">`));
              } else {
                updatedLine = updatedLine.replace(/\${(.*?)\}/, data[match]);
              }
            } else {
              updatedLine = updatedLine.replace(/\${(.*?)\}/, "");
            }
          }
          populatedLines.push(updatedLine);
        } else {
          populatedLines.push(line.replace(/\${(.*?)\}/, ""));
        }
      }
      else {
        populatedLines.push(line);
      }
    })
  }
  return populatedLines;
}

const populateTemplate = (template, data, repeatData) => {
  if (!template)
    return;
  const templateLines = template.replaceAll("\r","").replaceAll("\t","").split("\n");
  const repeatStart = __.findIndex(templateLines, (e) => { return e === "${repeat}"});
  const repeatEnd = __.findIndex(templateLines, (e) => { return e === "${endRepeat}"});
  const repeatLines = repeatStart + repeatEnd > 0 ? __.slice(templateLines, repeatStart + 1, repeatEnd) : [];

  if (repeatLines.length > 0) {
    let populatedLines = [];
    const header = __.slice(templateLines, 0, repeatStart);
    const footer = __.slice(templateLines, repeatEnd + 1, templateLines.length);

    populatedLines = updateParameters(header, data);
    if (repeatData && Array.isArray(repeatData)) {
      repeatData.forEach(repeat => {
        populatedLines = __.concat(populatedLines, updateParameters(repeatLines, repeat));
      })
    }
    populatedLines = __.concat(populatedLines, updateParameters(footer, data));
    return populatedLines.join("\n");
  } else {
    return updateParameters(templateLines, data).join("\n");
  }
}

const populateComplexTemplate = (template, data, repeatData) => {
  const templateLines = template.replaceAll("\r","").replaceAll("\t","").split("\n");
  const blocks = [];
  let repeatBlockCount = 0;
  if (Array.isArray(templateLines) && templateLines.length > 0) {
    let inRepeatBlock = false;
    templateLines.forEach((line, i) => {
      if (line === "${repeat}") {
        const dataBlock = __.last(blocks);
        if (dataBlock)
          dataBlock["endBlock"] = i - 1;
        blocks.push({blockType: "repeat", startBlock: i});
        inRepeatBlock = true;
        repeatBlockCount++;
      } else if (line === "${endRepeat}") {
        const repeatBlock = __.last(blocks);
        if (repeatBlock)
          repeatBlock["endBlock"] = i;
        blocks.push({blockType: "data", startBlock: i + 1});
        inRepeatBlock = false;
      } else {
        if ( !inRepeatBlock) {
          const dataBlock = __.last(blocks);
          if (dataBlock) {
            if (__.has(dataBlock, "endBlock")) {
              blocks.push({blockType: "data", startBlock: i});
            }
          } else {
            blocks.push({blockType: "data", startBlock: i});
          }
        }
      }
    });
    if (inRepeatBlock) {
      const repeatBlock = __.last(blocks);
      if (repeatBlock)
        repeatBlock["endBlock"] = templateLines.length - 1;
    } else {
      const dataBlock = __.last(blocks);
      if (dataBlock)
        dataBlock["endBlock"] = templateLines.length - 1;
    }

    if (blocks.length > 0) {
      let populatedLines = [];
      let repeatBlockIndex = 0;
      blocks.forEach(block => {
        if (block.blockType === "data") {
          const lines = block.startBlock + block.endBlock > 0 ? __.slice(templateLines, block.startBlock, block.endBlock) : [];
          populatedLines = __.concat(populatedLines, updateParameters(lines, data));
        } else {
          const lines = block.startBlock + block.endBlock > 0 ? __.slice(templateLines, block.startBlock + 1, block.endBlock) : [];
          if (repeatBlockCount > 1) {
            if (repeatData && Array.isArray(repeatData)) {
              if (repeatData.length > repeatBlockIndex && Array.isArray(repeatData[repeatBlockIndex])) {
                repeatData[repeatBlockIndex].forEach(repeat => {
                  populatedLines = __.concat(populatedLines, updateParameters(lines, repeat));
                })
              }
            }
            repeatBlockIndex++;
          } else {
            if (repeatData && Array.isArray(repeatData)) {
              repeatData.forEach(repeat => {
                populatedLines = __.concat(populatedLines, updateParameters(lines, repeat));
              })
            }
          }
        }
      });
      return populatedLines.join("\n");
    }
  }
}

export {
  populateTemplate,
  populateComplexTemplate
}
